import React from 'react';

import { RowOverflow } from 'hooks/useRowOverflow';

import { EdgeFade, ScrollButton, StyledChevronLeftIcon, StyledChevronRightIcon } from './styles';

type ScrollControlsProps = {
  overflow: RowOverflow;
  onScroll: (direction: -1 | 1) => void;
  /** Height of the row, so the buttons centre on it. */
  height: number;
};

/** Fade and chevron at whichever edge of a scrolling row has more behind it. Render inside a ScrollViewport. */
const ScrollControls = ({ overflow, onScroll, height }: ScrollControlsProps): React.ReactElement => (
  <>
    <EdgeFade $side="left" $visible={overflow.left} $height={height} />
    <EdgeFade $side="right" $visible={overflow.right} $height={height} />
    <ScrollButton
      type="button"
      $side="left"
      $visible={overflow.left}
      $height={height}
      aria-label="Scroll left"
      onClick={() => onScroll(-1)}
    >
      <StyledChevronLeftIcon />
    </ScrollButton>
    <ScrollButton
      type="button"
      $side="right"
      $visible={overflow.right}
      $height={height}
      aria-label="Scroll right"
      onClick={() => onScroll(1)}
    >
      <StyledChevronRightIcon />
    </ScrollButton>
  </>
);

export default ScrollControls;
